import { Routes } from '@angular/router';
import { AuthGuard } from '@src/app/_guards/auth.guard';
import { MailerComponent } from './components/mailer/mailer.component';

export const MAILER_ROUTES: Routes = [
    {
        path: 'mailer',
        children: [
            {
                path: '',
                component: MailerComponent,
                data: {
                    title: 'Nástěnka',
                    breadcrumb: [
                        {
                            label: 'Nástěnka',
                            url: '',
                        },
                    ],
                },
            },
        ],
        canActivate: [AuthGuard],
    },
];
